<template>
  <div class="v2_dialog_container">
    <div v-if="visible" class="v2_dialog_backdrop" @click="closeDialog"></div>

    <div v-if="visible" class="v2_dialog">
      <div class="v2_dialog_header">
        <h2 class="v2_dialog_header_title">{{ title }}</h2>

        <button
          class="v2_dialog_header_close_btn"
          aria-label="close"
          @click="closeDialog"
        >
          <vs-icon
            class="text-sm"
            icon-pack="feather"
            icon="icon-x"
            color="white"
          ></vs-icon>
        </button>
      </div>

      <div class="v2_dialog_content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Dialog Title',
    },
  },

  methods: {
    openDialog() {
      this.visible = true;
    },

    closeDialog() {
      this.visible = false;
      this.$emit('close');
    },
  },

  data() {
    return {
      visible: false,
    };
  },
};
</script>

<style lang="scss">
.v2_dialog {
  position: absolute;
  top: 10vh;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 500px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  overflow: hidden;
}

.v2_dialog_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #e7f4fb;
}

.v2_dialog_header_title {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  text-align: left;
  color: #434343;
}

.v2_dialog_header_close_btn {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  background: #0f4173;
  outline: transparent;
  border: 0;
  cursor: pointer;

  &:hover {
    background: #145699;
  }
}

.v2_dialog_content {
  padding: 16px 24px;
}

.v2_dialog_backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
}
</style>
